import { services } from 'services/base';
import { getMainConfig } from 'utils';

const initProductsServices = () => {
  const products = getMainConfig('products') || [];

  services.registerCollection('appFrame.products', products);
};

export default initProductsServices;
